import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PageAddManufacturer from '../../pages/Manufacturers/Add';

const ModalAddManufacturer = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddManufacturer handleModalClose={handleModalClose} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddManufacturer.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool
};

export default ModalAddManufacturer;
